function normalizeCountries(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => String(item || '').trim().toUpperCase())
      .filter(Boolean);
  }

  if (value && typeof value === 'object') {
    return Object.values(value)
      .map((item) => String(item || '').trim().toUpperCase())
      .filter(Boolean);
  }

  return [];
}

function normalizeJurisdictions(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  const candidates = [
    payload?.jurisdictions,
    payload?.jurisdiction,
    payload?.items,
    payload?.data,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate;
    }
    if (candidate && typeof candidate === 'object') {
      const values = Object.values(candidate);
      if (values.length > 0 && values.some((item) => item && typeof item === 'object' && ('uid' in item || 'name' in item))) {
        return values;
      }
    }
  }

  if (payload && typeof payload === 'object' && (payload.uid || payload.id || payload.name)) {
    return [payload];
  }

  return [];
}

export function mapJurisdictionsResponseToDto(payload) {
  return normalizeJurisdictions(payload).map((item, index) => ({
    id: String(item?.uid || item?.id || `jurisdiction-${index}`),
    name: String(item?.name || '').trim(),
    byDefault: Boolean(item?.byDefault ?? item?.default ?? item?.isDefault),
    countries: normalizeCountries(item?.countries),
  }));
}

export function mapCountryOptionsResponseToDto(payload) {
  const raw = payload?.countries ?? payload?.items ?? payload?.data ?? payload;
  const list = Array.isArray(raw) ? raw : (raw && typeof raw === 'object' ? Object.values(raw) : []);

  const options = list
    .map((item) => {
      if (typeof item === 'string') {
        const value = item.trim().toUpperCase();
        if (!value) {
          return null;
        }
        return { value, label: value };
      }

      if (!item || typeof item !== 'object') {
        return null;
      }

      const value = String(item.code || item.value || item.country || '').trim().toUpperCase();
      if (!value) {
        return null;
      }
      const name = String(item.name || item.label || '').trim();
      return { value, label: name ? `${value} - ${name}` : value };
    })
    .filter(Boolean);

  const uniq = new Map();
  options.forEach((option) => {
    uniq.set(option.value, option);
  });

  return Array.from(uniq.values()).sort((a, b) => a.value.localeCompare(b.value));
}

export function buildJurisdictionPayloadFromForm(form) {
  const countries = Array.isArray(form?.countries)
    ? form.countries.map((item) => String(item || '').trim().toUpperCase()).filter(Boolean)
    : [];

  return {
    name: String(form?.name || '').trim(),
    byDefault: Boolean(form?.byDefault),
    countries,
  };
}

